<template>
  <div>

    <Row :gutter="16">
      <!--<Col span="12">
        <Card dis-hover title="加油站信息">
          <pageTable ref="table"
                     :showPage="false"
                     :searchData="oilRangeForm"
                     :tableTitle="oilRangeColumn"
                     tableApi="admin/finance/companyData"
                     :tableHeight="600"
          >
            <template v-slot:searchFormItem>
              <FormItem prop="searchDay">
                <DatePicker v-model="oilRangeForm.searchDay" type="date" placeholder="时间" style="width: 200px"></DatePicker>
              </FormItem>
            </template>
          </pageTable>
        </Card>
      </Col>-->

      <Col span="24">
        <Card dis-hover bordered>
          <pageTable ref="table"
                     :showPage="false"
                     :searchData="oilRangeForm"
                     :tableTitle="companyOilRangeColumn"
                     tableApi="admin/finance/companyData"
          >
            <template v-slot:searchFormItem>
              <FormItem prop="searchDay">
                <DatePicker v-model="oilRangeForm.searchDay" type="daterange" placeholder="时间" style="width: 260px"></DatePicker>
              </FormItem>
                <FormItem prop="key">
                    <Input  v-model="oilRangeForm.key" placeholder="查询KEY"></Input>
                </FormItem>
            </template>
            <template v-slot:otherBtn>
              <!--<FormItem>
                <Button type="info">导出</Button>
              </FormItem>-->
              <FormItem>
                <Button type="info" @click="exportDetail">导出明细</Button>
              </FormItem>
            </template>
          </pageTable>
        </Card>
      </Col>
    </Row>

  </div>


</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'
  export default {
    name: "home",
    components:{pageTable},
    data(){
      return {
        companyOilRangeColumn:[
          {title: '车队名称',key: 'company_name',align: "left"},
          {title: '业务类型',key: 'station_name',align: "left",render:(h,params)=>{
            if (params.row.company_name==='汇总'){
              return h('span','')
            }else{
              return h('span',params.row.is_bill === 1 ? 'A型' : 'B型')
            }
            }},
          {title: '业务员',key: 'salesman',align: "left"},
          {title: '加油数量',key: 'litre_num',align: "left"},
          {title: '车队金额',key: 'company_price',align: "left"},
          // {title: '总成本',key: 'total_price',align: "left"},
          {title: '成本A',key: 'bill_price',align: "left"},
          {title: '成本B',key: 'no_bill_price',align: "left"},
          {title: '毛利润',key: 'profit',align: "left",render:(h,params)=>{
              return h('span',{
                style:{
                  color:params.row.profit>0 ? 'black':'red'
                }
              },params.row.profit)
            }},
        ],
        oilRangeForm:{
          searchDay:'',
          key:''
        }
      }
    },
    methods:{
      /*async getInfo(){
        let res = await this.$commonFun.postProxy('admin/finance/getInfo')
        this.isShow = res.data.isShow
      },*/
      turnToPage(name){
        this.$commonFun.jumpTo('',name)
      },
      exportDetail(){
        this.$commonFun.postProxy('admin/finance/exportDetailData',this.oilRangeForm).then((res)=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`财务统计.xlsx`)
        })
      }
    },
    mounted(){

    },
    created() {
      // this.getInfo()
    }
  }
</script>

<style scoped>

</style>
